module.exports = __webpack_public_path__ + "static/erp-description-f6bf8476bcfa4399f937824a79cf9f7f.jpeg";